import { render, staticRenderFns } from "./WorkTimeBox.vue?vue&type=template&id=881a51e4&"
import script from "./WorkTimeBox.vue?vue&type=script&lang=js&"
export * from "./WorkTimeBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports